// src/components/ContactButton.tsx
import { useState } from 'react';
import { ContactForm } from './ContactForm';
import './ContactButton.css';

export const ContactButton = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleOpen = () => setIsFormOpen(true);
  const handleClose = () => setIsFormOpen(false);

  return (
    <>
      {/* Show button only when form is NOT open */}
      {!isFormOpen && (
        <button
          className="floating-contact-button"
          onClick={handleOpen}
          aria-label="Contact AccordiaPro"
        >
          ✉️ Contact
        </button>
      )}

      <ContactForm isOpen={isFormOpen} onClose={handleClose} />
    </>
  );
};
